import PropTypes from 'prop-types';
import styles from './footer.module.scss';
import Navigation from './navigation/navigation';
import TrustedBadge from './trustedBadge/trustedBadge';
import useWebView from '../../hooks/useWebView';

export default function Footer({
  navigation = [],
  trustedBadge = {},
  borderTop,
}) {
  const isWebView = useWebView();

  if (isWebView) {
    return null;
  }

  return (
    <div className={styles.footer}>
      <div className={`${styles.container}  ${borderTop && styles.borderTop}`}>
        {navigation?.length > 0 && (
          <div className={`${styles.section} ${styles.borderBottom}`}>
            <Navigation navigation={navigation} />
          </div>
        )}
        {trustedBadge && (
          <div className={`${styles.section} ${styles.borderBottom}`}>
            <TrustedBadge {...trustedBadge} />
          </div>
        )}
      </div>
    </div>
  );
}

Footer.propTypes = {
  navigation: PropTypes.array,
  trustedBadge: PropTypes.object,
};
